export default "__VITE_ASSET__ByB9Hjhj__"